/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Component, Vue } from 'vue-property-decorator';
import SelectCardApi from '@/api/cardBind';
import type { SelectCardInfo } from '@/api/cardBind/types';
import { setPageTitle } from '@/api/native/utils';
import AlipayDeductionEntry from '../alipay-deduction-entry/index.vue';

const style = require('./index.module.scss');
const defaultLogo = require('../card-bank-list/images/card@3x.png');

@Component({ name: 'MyCardList' })
export default class MyCardList extends Vue {
  private cardList: SelectCardInfo[] = [];

  private created() {
    setPageTitle('我的银行卡');

    this.getMycardList();
  }

  private async getMycardList() {
    const myCardList = await SelectCardApi.getMyBankList();
    const { bankCards: bankcardList } = myCardList || {};
    this.cardList = bankcardList;
  }

  private render() {
    const hasBankCard = this.cardList && !!this.cardList.length;

    return (
      <div class={style.cardList}>
        <AlipayDeductionEntry/>
        <div class={hasBankCard ? style.bank_list : style.noBankCard}>
          {hasBankCard
            && this.cardList.map((item) => {
              const bankLogo = (item.extendInfo && item.extendInfo.logo) || defaultLogo;
              const cardTypeName = Number(item.cardType) === 0 ? '储蓄卡' : '信用卡';

              return (
                <div class={style.card_bank_List_all}>
                  <div class={style.bank_info_list}>
                    <div class={style.img_bank}>
                      <div class={style.bank_img}>
                        <img src={bankLogo} width="70%" />
                      </div>
                      <div>
                        <span>{item.bankName}</span>
                        <span>&nbsp;{cardTypeName}</span>
                        ({item.cardNo})
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}
